module.exports = __webpack_public_path__ + "img/token-hunt-variant-3.bff3e849.webp";